import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { MyApi } from "../../MyApi";

export default function WhyChooseUs() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          MyApi.BASE_URL + MyApi.whychooseus,
          {
            headers: { Authorization: MyApi.SECRET_KEY },
          }
        );

        if (res.data.status && res.data.data) {
          setData(res.data.data);
        }
      } catch (err) {
        console.error("API Error:", err);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="WhyChooseUs">
      <Container>
        <Row className="align-items-center">
          
          {/* LEFT CONTENT */}
          <Col md={6} lg={6}>
            <h3>{data?.title || "Why Choose Us"}</h3>
 
            <div
          dangerouslySetInnerHTML={{
            __html: data?.pagecontent,
          }}
        /> 
          </Col>

          {/* RIGHT BUTTON */}
          <Col md={6} lg={6} className="text-center">
            <Link to="/booking" className="button_style">
              {data?.button_text || "Book Now"}
            </Link>
          </Col>

        </Row>
      </Container>
    </div>
  );
}